import { render } from "./ClipboardButton.vue?vue&type=template&id=2b47f436&scoped=true"
import script from "./ClipboardButton.vue?vue&type=script&lang=js"
export * from "./ClipboardButton.vue?vue&type=script&lang=js"

import "./ClipboardButton.vue?vue&type=style&index=0&id=2b47f436&scoped=true&lang=css"

import exportComponent from "/Users/tatana/Documents/Chext/dev/neatify_frnt-bck/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b47f436"]])

export default __exports__